<!-- 敏感词词库 -->
<template>
  <div>
    <el-card class="box-card set-card" style="position: relative">
      <div class="box-top">
        <span>敏感词词库</span>
        <span style="margin-left: 30px">搜索</span>
        <el-input
            style="width: 200px;margin-left: 10px"
            placeholder="请输入敏感词名称"
            v-model="Wordname">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-col :span="10">
          <el-button style="margin-left: 20px" type="primary theme-btn" class="btn" @click.native="searchRole">
            查询
          </el-button>
          <el-button type="info" class="btn" @click.native="reset">重置</el-button>
        </el-col>
      </div>
      <div class="text item">
        <el-table style="width: 100%" :data="articleData" class="table-content">
          <el-table-column align="center" show-overflow-tooltip width="100" label="序号" :fit="true"
                           type="index"></el-table-column>
          <el-table-column align="center" show-overflow-tooltip width="100" label="敏感词"
                           prop="sensitiveWord"></el-table-column>
          <el-table-column align="center" label='创建人' width="120" prop="createEmp"></el-table-column>
          <el-table-column align="center" label='发布时间' prop="createTime"></el-table-column>
          <el-table-column align="center" label='修改人' width="120" prop="updateEmp"></el-table-column>
          <el-table-column align="center" label='修改时间' prop="updateTime"></el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button @click="deleteClick(scope.row)" size="small" type="danger" class="table-compile">删除</el-button>
              <el-button type="primary" @click="modify(scope.row)" size="small" class="table-compile">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagelist" style="text-align: center">
        <el-row type="flex" justify="center">
          <el-col :span="24" class="nomore" style="margin-top:24px;">
            <!-- <span v-if="isShow">没有更多了</span> -->
            <el-pagination
                v-if="pagination"
                class="page"
                background
                :current-page="currentPage1"
                @current-change="current_page"
                layout="total, prev, pager, next, jumper"
                :total="dataNumber">
            </el-pagination>
          </el-col>
        </el-row>
      </div>

      <el-dialog title="敏感词修改" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <el-form :model="dataList" :rules="rules" ref="registerRef">
          <el-form-item label="敏感词" label-width="80px" prop="Sensitivetext">
            <el-input
                style="width: 400px"
                placeholder="请输入您需要修改的敏感词"
                v-model="dataList.Sensitivetext">
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="quitClick">取 消</el-button>
          <el-button type="primary" @click="SensitivAdd('registerRef')">确 定</el-button>
    </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import login from "@/views/login/login";

export default {
  data() {
    return {
      Wordname: "",
      page: 1,
      size: "10",
      dataNumber: 0, // 有多少条数据
      currentPage1: 1,
      articleData: [],
      pagination: true,
      dialogVisible: false,
      // Sensitivetext: "", // 敏感词修改
      dataList: {
        Sensitivetext: ""
      },
      rules: {
        Sensitivetext: [
          {required: true, message: '请输入敏感词', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
  },
  mounted() {
    this.getAricleFn(this.page, this.size, this.Wordname);
  },
  methods: {
    quitClick() {
      this.dialogVisible = false
      this.dataList.Sensitivetext = ""
      this.$refs.registerRef.clearValidate();
    },
    // 修改敏感词
    SensitivAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axiosPost(`/sensitiveWord/update`, {
            id: this.modifyId,
            sensitiveWord: this.dataList.Sensitivetext,
          }).then((res) => {
            if (res.code == 200) {
              this.dialogVisible = false
              this.$message.success(res.message)
              this.getAricleFn(this.page, this.size, this.Wordname)
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.$message.error('请输入敏感词')
        }
      })


    },
    // 修改
    modify(val) {
      this.modifyId = val.id
      this.dialogVisible = true
      this.dataList.Sensitivetext=val.sensitiveWord
    },
    // 关闭diog窗口
    handleClose() {
      this.dialogVisible = false
      this.dataList.Sensitivetext = ""
      this.$refs.registerRef.clearValidate();
    },
    // 删除敏感词
    deleteClick(val) {
      this.axiosPost(`/sensitiveWord/deleteById/${val.id}`,).then((res) => {
        if (res.code == 200) {
          this.getAricleFn(this.page, this.size, this.Wordname);
          this.$message.success('删除成功')
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    // 查询敏感词
    searchRole() {
      this.getAricleFn(1, 10, this.Wordname);
    },
    // 重置搜索
    reset() {
      this.Wordname = "";
      this.currentPage1 = 1
      this.getAricleFn(1, this.size, this.Wordname);
      this.pagination = false
      this.$nextTick(() => {
        this.pagination = true
      })
    },
    //分页
    current_page(currentPage) {
      this.page = currentPage;
      this.getAricleFn(this.page, this.size, this.Wordname);
    },
    //获取文章列表
    getAricleFn(page, size, Wordname) {
      this.axiosGet(`/sensitiveWord/page/${page}/${size}`, {
        params: {
          sensitiveWord: Wordname
        },
      }).then((res) => {
        if (res.code == 200) {
          this.articleData = res.data.list
          this.dataNumber = res.data.total
        }
      });
    },
  },
  filters: {
    checkVal(str) {
      let reg1 =
          /<img.*?>|<p>|<\/p>|<u>|<\/u>|<strong>|<\/strong>|<em>|<\/em>|<h1>|<\/h1>|<h2>|<\/h2>|<sub>|<\/sub>|<span.*?<\/span>|<sup>|<\/sup>|<h1.*?>|<sup.*?>/gi;
      str = str.replace(reg1, "").substring(0, 200);
      return str;
    },
  },

  updated() {
  },
}
;
</script>
<style lang="less" scoped>


.newsList-box {
  width: 100%;

  .newsItemBox {
    transition: .2s;
    padding-left: 30px;
    display: flex;
    justify-content: space-between;

    .title-Top {
      line-height: 60px;
      color: black;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 300px;

    }

    .BelongingContent {
      line-height: 60px;
      color: black;
    }

    .updateTime {
      line-height: 60px;
    }

    .content-bottom {
      line-height: 60px;
      margin-right: 30px;
    }
  }

  .newsItemBox:hover {
    box-shadow: 0px 3px 19px 5px rgba(42, 112, 255, 0.13);
  }
}

// 分页
.box-card {
  .box-top {
    padding: 20px 32px 0 30px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .sendNewsBtn {
      width: 136px;
      height: 48px;
      border: 2px solid #1A80FC;
      border-radius: 8px;
      background: #fff;
      color: #1A80FC;
    }
  }

}

.nomore {
  line-height: 50px;
  text-align: center;
  margin-top: 24px
  // margin-top:10px;
}

.small-title {
  position: absolute;
  top: 0;
  right: 0;
  width: 45%;
  height: 25px;
  background: rgba(0, 0, 0, .5);
  color: #ffffff;
  font-size: 9px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 25px;
  text-align: center;
  border-bottom-left-radius: 4px;
}
</style>
